import album from './album'
import artist from './artist'
import cloud from './cloud'
import login from './login'
import logout from './logout'
import mv from './mv'
import playlist from './playlist'
import search from './search'
import siginin from './siginin'
import song from './song'
import toplist from './toplist'
import user from './user'

export default {
  login,
  playlist,
  song,
  user,
  artist,
  logout,
  siginin,
  cloud,
  search,
  album,
  toplist,
  mv
}
